import { SvgIcon } from "@mui/material";
import { ReactComponent as GWLogo } from "./gwlogo.svg";

export function GWWarhammerIcon(props) {
  return (
    <SvgIcon>
      <GWLogo />
    </SvgIcon>
  );
}

export function GWSearch(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_414_13940)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6501 2.14996C6.0938 2.14996 2.40015 5.84361 2.40015 10.4C2.40015 14.9563 6.0938 18.65 10.6501 18.65C15.2065 18.65 18.9001 14.9563 18.9001 10.4C18.9001 5.84361 15.2065 2.14996 10.6501 2.14996ZM0.900146 10.4C0.900146 5.01519 5.26537 0.649963 10.6501 0.649963C16.0349 0.649963 20.4001 5.01519 20.4001 10.4C20.4001 12.8224 19.5167 15.0386 18.0544 16.7437L24.1443 22.8336C24.4372 23.1265 24.4372 23.6014 24.1443 23.8943C23.8514 24.1872 23.3765 24.1872 23.0836 23.8943L16.9937 17.8044C15.2886 19.2666 13.0725 20.15 10.6501 20.15C5.26537 20.15 0.900146 15.7847 0.900146 10.4Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_414_13940">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.75 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function GWLocationDot(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.60138 9.15591C5.4946 5.23032 8.83646 3.24769 12.2532 3.25C15.6701 3.25231 19.0099 5.23971 19.8985 9.16556L19.8985 9.1656C20.9556 13.8354 18.0624 17.8756 15.3305 20.499L15.3291 20.5004C13.6106 22.159 10.8907 22.161 9.16015 20.4997C6.43804 17.8762 3.54432 13.8261 4.60138 9.15591ZM12.2542 1.75C16.2348 1.75269 20.29 4.10029 21.3615 8.83441C22.6042 14.3239 19.1783 18.8834 16.3704 21.58C14.0691 23.8008 10.4298 23.7989 8.12045 21.5809L8.1195 21.58C5.32175 18.8836 1.89576 14.3139 3.13847 8.82441L3.13864 8.82364C4.21557 4.08953 8.27358 1.74731 12.2542 1.75ZM9.88001 10.81C9.88001 9.50109 10.9411 8.44 12.25 8.44C13.5589 8.44 14.62 9.50109 14.62 10.81C14.62 12.1189 13.5589 13.18 12.25 13.18C10.9411 13.18 9.88001 12.1189 9.88001 10.81ZM12.25 6.94C10.1127 6.94 8.38001 8.67266 8.38001 10.81C8.38001 12.9473 10.1127 14.68 12.25 14.68C14.3874 14.68 16.12 12.9473 16.12 10.81C16.12 8.67266 14.3874 6.94 12.25 6.94Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWBars(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 7.5C3 7.08579 3.33579 6.75 3.75 6.75H21.75C22.1642 6.75 22.5 7.08579 22.5 7.5C22.5 7.91421 22.1642 8.25 21.75 8.25H3.75C3.33579 8.25 3 7.91421 3 7.5ZM3 12.5C3 12.0858 3.33579 11.75 3.75 11.75H21.75C22.1642 11.75 22.5 12.0858 22.5 12.5C22.5 12.9142 22.1642 13.25 21.75 13.25H3.75C3.33579 13.25 3 12.9142 3 12.5ZM3 17.5C3 17.0858 3.33579 16.75 3.75 16.75H21.75C22.1642 16.75 22.5 17.0858 22.5 17.5C22.5 17.9142 22.1642 18.25 21.75 18.25H3.75C3.33579 18.25 3 17.9142 3 17.5Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWTicket(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.71967 4.96967C3.70818 3.98116 5.25536 3.75 7.25 3.75H17.25C19.2446 3.75 20.7918 3.98116 21.7803 4.96967C22.7688 5.95818 23 7.50536 23 9.5V10.5C23 10.9142 22.6642 11.25 22.25 11.25C21.2842 11.25 20.5 12.0342 20.5 13C20.5 13.9658 21.2842 14.75 22.25 14.75C22.6642 14.75 23 15.0858 23 15.5C23 17.4946 22.7688 19.0418 21.7803 20.0303C20.7918 21.0188 19.2446 21.25 17.25 21.25H7.25C5.25536 21.25 3.70818 21.0188 2.71967 20.0303C1.73116 19.0418 1.5 17.4946 1.5 15.5V15C1.5 14.5858 1.83579 14.25 2.25 14.25C3.21579 14.25 4 13.4658 4 12.5C4 11.5342 3.21579 10.75 2.25 10.75C1.83579 10.75 1.5 10.4142 1.5 10V9.5C1.5 7.50536 1.73116 5.95818 2.71967 4.96967ZM3.00061 9.3372C4.43324 9.67623 5.5 10.9641 5.5 12.5C5.5 14.0359 4.43324 15.3238 3.00061 15.6628C3.01494 17.5573 3.28288 18.4722 3.78033 18.9697C4.29182 19.4812 5.24464 19.75 7.25 19.75H17.25C19.2554 19.75 20.2082 19.4812 20.7197 18.9697C21.1714 18.5179 21.4339 17.7218 21.489 16.1603C20.0616 15.8176 19 14.5322 19 13C19 11.4639 20.0671 10.1759 21.5 9.83706V9.5C21.5 7.49464 21.2312 6.54182 20.7197 6.03033C20.2082 5.51884 19.2554 5.25 17.25 5.25H7.25C5.24464 5.25 4.29182 5.51884 3.78033 6.03033C3.28288 6.52778 3.01494 7.44266 3.00061 9.3372Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.7803 8.71967C16.0732 9.01256 16.0732 9.48744 15.7803 9.78033L9.78033 15.7803C9.48744 16.0732 9.01256 16.0732 8.71967 15.7803C8.42678 15.4874 8.42678 15.0126 8.71967 14.7197L14.7197 8.71967C15.0126 8.42678 15.4874 8.42678 15.7803 8.71967Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.2445 15.25C14.2445 14.6977 14.6922 14.25 15.2445 14.25H15.2535C15.8058 14.25 16.2535 14.6977 16.2535 15.25C16.2535 15.8023 15.8058 16.25 15.2535 16.25H15.2445C14.6922 16.25 14.2445 15.8023 14.2445 15.25Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.24451 9.75C8.24451 9.19772 8.69222 8.75 9.24451 8.75H9.25349C9.80577 8.75 10.2535 9.19772 10.2535 9.75C10.2535 10.3023 9.80577 10.75 9.25349 10.75H9.24451C8.69222 10.75 8.24451 10.3023 8.24451 9.75Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWPlay(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.12 21.78C7.33 21.78 6.58 21.59 5.92 21.21C4.36 20.31 3.5 18.48 3.5 16.07V8.93999C3.5 6.51999 4.36 4.69999 5.92 3.79999C7.48 2.89999 9.49 3.06999 11.59 4.27999L17.76 7.83999C19.85 9.04999 21.01 10.71 21.01 12.51C21.01 14.31 19.86 15.97 17.76 17.18L11.59 20.74C10.38 21.43 9.2 21.78 8.12 21.78ZM8.12 4.71999C7.58 4.71999 7.1 4.83999 6.67 5.08999C5.59 5.70999 5 7.07999 5 8.93999V16.06C5 17.92 5.59 19.28 6.67 19.91C7.75 20.54 9.23 20.36 10.84 19.43L17.01 15.87C18.62 14.94 19.51 13.75 19.51 12.5C19.51 11.25 18.62 10.06 17.01 9.12999L10.84 5.56999C9.86 5.00999 8.94 4.71999 8.12 4.71999Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWPause(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.70078 3.39279C4.23336 2.89117 4.9759 2.75 5.76 2.75H9.39C10.1741 2.75 10.9166 2.89117 11.4492 3.39279C11.9933 3.90519 12.15 4.63203 12.15 5.39V19.61C12.15 20.368 11.9933 21.0948 11.4492 21.6072C10.9166 22.1088 10.1741 22.25 9.39 22.25H5.76C4.9759 22.25 4.23336 22.1088 3.70078 21.6072C3.15674 21.0948 3 20.368 3 19.61V5.39C3 4.63203 3.15674 3.90519 3.70078 3.39279ZM4.72922 4.48471C4.62826 4.57981 4.5 4.79797 4.5 5.39V19.61C4.5 20.202 4.62826 20.4202 4.72922 20.5153C4.84164 20.6212 5.1041 20.75 5.76 20.75H9.39C10.0459 20.75 10.3084 20.6212 10.4208 20.5153C10.5217 20.4202 10.65 20.202 10.65 19.61V5.39C10.65 4.79797 10.5217 4.57981 10.4208 4.48471C10.3084 4.37883 10.0459 4.25 9.39 4.25H5.76C5.1041 4.25 4.84164 4.37883 4.72922 4.48471ZM14.0556 3.39179C14.5885 2.89176 15.3294 2.75 16.11 2.75H19.74C20.5241 2.75 21.2666 2.89117 21.7992 3.39279C22.3433 3.90519 22.5 4.63203 22.5 5.39V19.61C22.5 20.368 22.3433 21.0948 21.7992 21.6072C21.2666 22.1088 20.5241 22.25 19.74 22.25H16.11C15.3259 22.25 14.5834 22.1088 14.0508 21.6072C13.5067 21.0948 13.35 20.368 13.35 19.61V5.39C13.35 4.62889 13.5107 3.90304 14.0556 3.39179ZM15.0819 4.48571C14.9793 4.58196 14.85 4.80111 14.85 5.39V19.61C14.85 20.202 14.9783 20.4202 15.0792 20.5153C15.1916 20.6212 15.4541 20.75 16.11 20.75H19.74C20.3959 20.75 20.6584 20.6212 20.7708 20.5153C20.8717 20.4202 21 20.202 21 19.61V5.39C21 4.79797 20.8717 4.57981 20.7708 4.48471C20.6584 4.37883 20.3959 4.25 19.74 4.25H16.11C15.4606 4.25 15.1965 4.37824 15.0819 4.48571Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWArrowLeft(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.7502 13.2499C21.1644 13.2499 21.5002 12.9142 21.5002 12.4999C21.5002 12.0857 21.1644 11.7499 20.7502 11.7499H5.56089L10.3505 6.96032C10.6434 6.66743 10.6434 6.19256 10.3505 5.89966C10.0576 5.60677 9.58274 5.60677 9.28985 5.89966L3.21984 11.9697C3.07919 12.1103 3.00018 12.3011 3.00018 12.5C3.00018 12.6989 3.07919 12.8897 3.21984 13.0303L9.28985 19.1003C9.58274 19.3932 10.0576 19.3932 10.3505 19.1003C10.6434 18.8074 10.6434 18.3326 10.3505 18.0397L5.56078 13.2499H20.7502Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWChevronDown(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.2803 8.96967C19.5732 9.26256 19.5732 9.73744 19.2803 10.0303L13.2803 16.0303C12.9874 16.3232 12.5126 16.3232 12.2197 16.0303L6.21967 10.0303C5.92678 9.73744 5.92678 9.26256 6.21967 8.96967C6.51256 8.67678 6.98744 8.67678 7.28033 8.96967L12.75 14.4393L18.2197 8.96967C18.5126 8.67678 18.9874 8.67678 19.2803 8.96967Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWChevronUp(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.71967 16.0303C5.42678 15.7374 5.42678 15.2626 5.71967 14.9697L11.7197 8.96967C12.0126 8.67678 12.4874 8.67678 12.7803 8.96967L18.7803 14.9697C19.0732 15.2626 19.0732 15.7374 18.7803 16.0303C18.4874 16.3232 18.0126 16.3232 17.7197 16.0303L12.25 10.5607L6.78033 16.0303C6.48744 16.3232 6.01256 16.3232 5.71967 16.0303Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWChevronLeft(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.2803 5.96967C15.9874 5.67678 15.5126 5.67678 15.2197 5.96967L9.21967 11.9697C8.92678 12.2626 8.92678 12.7374 9.21967 13.0303L15.2197 19.0303C15.5126 19.3232 15.9874 19.3232 16.2803 19.0303C16.5732 18.7374 16.5732 18.2626 16.2803 17.9697L10.8107 12.5L16.2803 7.03033C16.5732 6.73744 16.5732 6.26256 16.2803 5.96967Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWChevronRight(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.71967 5.96967C9.01256 5.67678 9.48744 5.67678 9.78033 5.96967L15.7803 11.9697C16.0732 12.2626 16.0732 12.7374 15.7803 13.0303L9.78033 19.0303C9.48744 19.3232 9.01256 19.3232 8.71967 19.0303C8.42678 18.7374 8.42678 18.2626 8.71967 17.9697L14.1893 12.5L8.71967 7.03033C8.42678 6.73744 8.42678 6.26256 8.71967 5.96967Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWStar(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.48 4.01001L16.24 7.53001C16.48 8.02001 17.12 8.49001 17.66 8.58001L20.85 9.11001C22.89 9.45001 23.37 10.93 21.9 12.39L19.42 14.87C19 15.29 18.77 16.1 18.9 16.68L19.61 19.75C20.17 22.18 18.88 23.12 16.73 21.85L13.74 20.08C13.2 19.76 12.31 19.76 11.76 20.08L8.77 21.85C6.63 23.12 5.33 22.17 5.89 19.75L6.6 16.68C6.73 16.1 6.5 15.29 6.08 14.87L3.6 12.39C2.14 10.93 2.61 9.45001 4.65 9.11001L7.84 8.58001C8.37 8.49001 9.01 8.02001 9.25 7.53001L11.01 4.01001C11.97 2.10001 13.53 2.10001 14.48 4.01001Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWStarOutline(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.1801 4.34683C11.18 4.34702 11.1802 4.34664 11.1801 4.34683L9.42206 7.86294C9.23472 8.24378 8.92181 8.5692 8.60045 8.80747C8.27816 9.04644 7.87767 9.24945 7.46556 9.31943L7.46292 9.31988L4.2733 9.84981C4.27317 9.84983 4.27342 9.84979 4.2733 9.84981C3.3837 9.99816 3.0939 10.3485 3.02696 10.5582C2.95977 10.7685 2.99333 11.2227 3.63033 11.8597L6.11033 14.3397C6.43272 14.6621 6.64837 15.0932 6.76729 15.5086C6.8863 15.9244 6.93081 16.4025 6.83184 16.844L6.83073 16.849L6.12071 19.919C5.85629 21.0617 6.12375 21.4788 6.25958 21.5779C6.39599 21.6774 6.87635 21.805 7.88723 21.205L10.8828 19.4317C11.2988 19.1897 11.7969 19.09 12.2537 19.09C12.7099 19.09 13.2082 19.1894 13.6221 19.4346C13.622 19.4346 13.6222 19.4347 13.6221 19.4346L16.6114 21.2043C16.6112 21.2041 16.6116 21.2044 16.6114 21.2043C17.6306 21.8061 18.1105 21.6791 18.2444 21.5815C18.3771 21.4847 18.6446 21.0702 18.3792 19.9184L17.6681 16.8441C17.5692 16.4025 17.6137 15.9244 17.7327 15.5086C17.8516 15.0932 18.0673 14.6621 18.3897 14.3397L20.8697 11.8597L20.8715 11.8579C21.5127 11.221 21.5443 10.7681 21.4772 10.5595C21.4096 10.3493 21.1174 9.99835 20.2271 9.84987C20.2269 9.84985 20.2272 9.84989 20.2271 9.84987L17.0371 9.31987C16.6207 9.25048 16.2171 9.04824 15.8922 8.80851C15.5686 8.56977 15.2554 8.24405 15.068 7.863L13.3085 4.34402C12.8877 3.498 12.46 3.32751 12.2487 3.32751C12.0361 3.32751 11.6058 3.50015 11.1801 4.34683ZM14.6512 3.67535C14.122 2.61171 13.2947 1.82751 12.2487 1.82751C11.2039 1.82751 10.3741 2.61037 9.83988 3.6732L8.07918 7.1946L8.07645 7.20011C8.02362 7.30797 7.89734 7.46146 7.70705 7.60256C7.51741 7.74317 7.33343 7.82012 7.2155 7.84042C7.21514 7.84048 7.21479 7.84054 7.21444 7.8406L4.02708 8.37016C2.87697 8.56184 1.91109 9.12155 1.59804 10.1019C1.28522 11.0815 1.74666 12.0973 2.56967 12.9203L5.04967 15.4003C5.14728 15.498 5.25663 15.6818 5.32521 15.9214C5.39337 16.1595 5.39914 16.3755 5.36859 16.514C5.36845 16.5147 5.3683 16.5153 5.36816 16.516L4.65931 19.5809C4.6593 19.581 4.65931 19.5809 4.65931 19.5809C4.36376 20.8582 4.46627 22.1263 5.37542 22.7896C6.28401 23.4526 7.52365 23.1651 8.65276 22.495L11.6372 20.7283C11.6378 20.7279 11.6384 20.7276 11.639 20.7272C11.7733 20.6497 11.9944 20.59 12.2537 20.59C12.515 20.59 12.7316 20.6505 12.8576 20.7252L15.8479 22.4954C16.9784 23.1632 18.2196 23.4559 19.1281 22.7936C20.0379 22.1303 20.1354 20.8599 19.8408 19.5816L19.1318 16.516C19.1317 16.5153 19.1315 16.5147 19.1314 16.514C19.1009 16.3755 19.1066 16.1595 19.1748 15.9214C19.2434 15.6818 19.3527 15.498 19.4503 15.4003L21.9285 12.9222C21.9289 12.9218 21.9292 12.9215 21.9295 12.9211C22.7577 12.0982 23.2206 11.0815 22.9053 10.1005C22.5904 9.1208 21.6226 8.56178 20.4733 8.37022L17.2833 7.84022C17.2832 7.8402 17.2834 7.84024 17.2833 7.84022M14.6512 3.67535C14.6511 3.67513 14.6513 3.67557 14.6512 3.67535V3.67535Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWTrash(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_414_14168)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 1.25C9 0.835786 9.33579 0.5 9.75 0.5H15.75C16.1642 0.5 16.5 0.835786 16.5 1.25C16.5 1.41887 16.4442 1.57471 16.35 1.70007H21.75C22.5784 1.70007 23.25 2.37165 23.25 3.20007V4.70007C23.25 5.5285 22.5784 6.20007 21.75 6.20007H20.872C20.9549 6.43466 21 6.6871 21 6.95007V21.9501C21 23.1927 19.9926 24.2001 18.75 24.2001H6.75C5.50736 24.2001 4.5 23.1927 4.5 21.9501V6.95007C4.5 6.6871 4.54512 6.43466 4.62803 6.20007H3.75C2.92157 6.20007 2.25 5.5285 2.25 4.70007V3.20007C2.25 2.37165 2.92157 1.70007 3.75 1.70007H9.15C9.05581 1.57471 9 1.41887 9 1.25ZM18.75 6.20007H6.75C6.33579 6.20007 6 6.53586 6 6.95007V21.9501C6 22.3643 6.33579 22.7001 6.75 22.7001H18.75C19.1642 22.7001 19.5 22.3643 19.5 21.9501V6.95007C19.5 6.53586 19.1642 6.20007 18.75 6.20007ZM18.75 4.70007H21.75V3.20007H3.75V4.70007H6.75H18.75ZM13.5 9.35004C13.5 8.93582 13.1642 8.60004 12.75 8.60004C12.3358 8.60004 12 8.93582 12 9.35004V19.85C12 20.2642 12.3358 20.6 12.75 20.6C13.1642 20.6 13.5 20.2642 13.5 19.85V9.35004ZM16.5 8.60004C16.9142 8.60004 17.25 8.93582 17.25 9.35004V19.85C17.25 20.2642 16.9142 20.6 16.5 20.6C16.0858 20.6 15.75 20.2642 15.75 19.85V9.35004C15.75 8.93582 16.0858 8.60004 16.5 8.60004ZM9.75 9.35004C9.75 8.93582 9.41421 8.60004 9 8.60004C8.58579 8.60004 8.25 8.93582 8.25 9.35004V19.85C8.25 20.2642 8.58579 20.6 9 20.6C9.41421 20.6 9.75 20.2642 9.75 19.85V9.35004Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_414_14168">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.25 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function GWUserGear(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.75 4.25C9.95507 4.25 8.5 5.70507 8.5 7.5C8.5 9.29493 9.95507 10.75 11.75 10.75C13.5449 10.75 15 9.29493 15 7.5C15 5.70507 13.5449 4.25 11.75 4.25ZM7 7.5C7 4.87665 9.12665 2.75 11.75 2.75C14.3734 2.75 16.5 4.87665 16.5 7.5C16.5 10.1234 14.3734 12.25 11.75 12.25C9.12665 12.25 7 10.1234 7 7.5ZM10.9239 15.25C6.71389 15.25 3.5 18.1496 3.5 21.5C3.5 21.9142 3.16421 22.25 2.75 22.25C2.33579 22.25 2 21.9142 2 21.5C2 17.1104 6.11315 13.75 10.9239 13.75C11.7914 13.75 12.634 13.8571 13.4348 14.0606C13.8362 14.1627 14.0789 14.5708 13.9769 14.9723C13.8748 15.3737 13.4667 15.6164 13.0652 15.5144C12.3863 15.3418 11.6679 15.25 10.9239 15.25Z"
          fill="currentColor"
        />
        <path
          d="M22.8 17.11C21.895 17.11 21.525 16.47 21.975 15.685C22.235 15.23 22.08 14.65 21.625 14.39L20.76 13.895C20.365 13.66 19.855 13.8 19.62 14.195L19.565 14.29C19.115 15.075 18.375 15.075 17.92 14.29L17.865 14.195C17.64 13.8 17.13 13.66 16.735 13.895L15.87 14.39C15.415 14.65 15.26 15.235 15.52 15.69C15.975 16.47 15.605 17.11 14.7 17.11C14.18 17.11 13.75 17.535 13.75 18.06V18.94C13.75 19.46 14.175 19.89 14.7 19.89C15.605 19.89 15.975 20.53 15.52 21.315C15.26 21.77 15.415 22.35 15.87 22.61L16.735 23.105C17.13 23.34 17.64 23.2 17.875 22.805L17.93 22.71C18.38 21.925 19.12 21.925 19.575 22.71L19.63 22.805C19.865 23.2 20.375 23.34 20.77 23.105L21.635 22.61C22.09 22.35 22.245 21.765 21.985 21.315C21.53 20.53 21.9 19.89 22.805 19.89C23.325 19.89 23.755 19.465 23.755 18.94V18.06C23.75 17.54 23.325 17.11 22.8 17.11ZM18.75 20.125C17.855 20.125 17.125 19.395 17.125 18.5C17.125 17.605 17.855 16.875 18.75 16.875C19.645 16.875 20.375 17.605 20.375 18.5C20.375 19.395 19.645 20.125 18.75 20.125Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWXmark(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.9198 20.2238C19.2299 20.5338 19.7191 20.5474 20.0124 20.2543C20.3057 19.9611 20.2921 19.4722 19.9819 19.1622L13.3263 12.5099L20.0167 5.82281C20.3204 5.51932 20.3287 5.03563 20.0354 4.74246C19.7421 4.4493 19.2582 4.45767 18.9545 4.76117L12.2641 11.4482L5.55424 4.7417C5.24411 4.43172 4.75492 4.41809 4.46161 4.71126C4.1683 5.00442 4.18193 5.49337 4.49207 5.80335L11.202 12.5099L4.50336 19.2051C4.19971 19.5086 4.19133 19.9923 4.48464 20.2855C4.77795 20.5786 5.26188 20.5703 5.56553 20.2668L12.2641 13.5715L18.9198 20.2238Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWAdd(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4 12.75C4 12.3358 4.33579 12 4.75 12H20.75C21.1642 12 21.5 12.3358 21.5 12.75C21.5 13.1642 21.1642 13.5 20.75 13.5H4.75C4.33579 13.5 4 13.1642 4 12.75Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.75 21.5C12.3358 21.5 12 21.1642 12 20.75L12 4.75C12 4.33578 12.3358 4 12.75 4C13.1642 4 13.5 4.33578 13.5 4.75L13.5 20.75C13.5 21.1642 13.1642 21.5 12.75 21.5Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWUpload(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.2491 2.75036C12.448 2.75036 12.6388 2.82938 12.7794 2.97003L19.3822 9.57293C19.6751 9.86583 19.6751 10.3407 19.3822 10.6336C19.0893 10.9265 18.6144 10.9265 18.3215 10.6336L12.9991 5.31101L12.9988 18.5013C12.9988 18.9155 12.663 19.2513 12.2488 19.2513C11.8345 19.2513 11.4988 18.9155 11.4988 18.5013L11.4991 5.31107L6.17658 10.6336C5.88369 10.9265 5.40881 10.9265 5.11592 10.6336C4.82302 10.3407 4.82302 9.86582 5.11592 9.57293L11.7188 2.97003C11.8594 2.82938 12.0502 2.75036 12.2491 2.75036ZM3 22.5C3 22.0858 3.33579 21.75 3.75 21.75H20.75C21.1642 21.75 21.5 22.0858 21.5 22.5C21.5 22.9142 21.1642 23.25 20.75 23.25H3.75C3.33579 23.25 3 22.9142 3 22.5Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWDownload(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.2487 2.75024C12.6629 2.75024 12.9987 3.08601 12.9987 3.50023L12.999 16.6904L18.3214 11.3678C18.6143 11.0749 19.0892 11.0748 19.3821 11.3677C19.675 11.6606 19.675 12.1355 19.3821 12.4284L12.7794 19.0313C12.6387 19.172 12.4479 19.251 12.249 19.251C12.0501 19.251 11.8593 19.172 11.7187 19.0313L5.11594 12.4284C4.82305 12.1355 4.82306 11.6606 5.11596 11.3677C5.40886 11.0748 5.88373 11.0749 6.17662 11.3678L11.499 16.6903L11.4987 3.50026C11.4987 3.08605 11.8345 2.75025 12.2487 2.75024ZM3 22.5C3 22.0858 3.33579 21.75 3.75 21.75H20.75C21.1642 21.75 21.5 22.0858 21.5 22.5C21.5 22.9142 21.1642 23.25 20.75 23.25H3.75C3.33579 23.25 3 22.9142 3 22.5Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWRemove(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4 12.75C4 12.3358 4.33579 12 4.75 12H20.75C21.1642 12 21.5 12.3358 21.5 12.75C21.5 13.1642 21.1642 13.5 20.75 13.5H4.75C4.33579 13.5 4 13.1642 4 12.75Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWFilters(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.6942 1.85002H19.35C20.8642 1.85002 22.1 3.08581 22.1 4.60002V6.80002C22.1 7.34154 21.9352 7.9001 21.7203 8.37287C21.5045 8.84767 21.2075 9.30314 20.8803 9.63035C20.8694 9.64125 20.8582 9.65181 20.8466 9.66202L16.5466 13.462C16.5412 13.4668 16.5357 13.4715 16.5301 13.4762C16.3471 13.6287 16.1587 13.8928 16.0154 14.2304C15.8736 14.5649 15.8 14.9154 15.8 15.2V19.5C15.8 19.9492 15.656 20.4179 15.4529 20.8085C15.254 21.191 14.9505 21.5904 14.5471 21.8363L13.1556 22.7309L13.1431 22.7388C11.3815 23.8228 8.89999 22.631 8.89999 20.4V15.1C8.89999 14.8781 8.83279 14.5765 8.70364 14.2536C8.58129 13.9477 8.42414 13.6747 8.28234 13.4914L4.51237 9.52303C4.18624 9.19455 3.91682 8.76528 3.72811 8.34431C3.5409 7.92669 3.39999 7.44326 3.39999 7.00002V4.70002C3.39999 3.10998 4.61202 1.85002 6.14999 1.85002H11.6671C11.6761 1.84986 11.6852 1.84986 11.6942 1.85002ZM7.58463 10.5791L12.096 3.35002H19.35C20.0358 3.35002 20.6 3.91423 20.6 4.60002V6.80002C20.6 7.0585 20.5148 7.39994 20.3547 7.75217C20.2 8.09262 20.0037 8.38044 19.8342 8.55496L15.5608 12.3315C15.1484 12.6784 14.8398 13.1608 14.6346 13.6446C14.4264 14.1352 14.3 14.6847 14.3 15.2V19.5C14.3 19.6508 14.244 19.8821 14.1221 20.1165C13.9978 20.3555 13.8551 20.5023 13.7641 20.5569C13.7575 20.5609 13.7509 20.565 13.7444 20.5691L12.3513 21.4647C11.5135 21.9746 10.4 21.3669 10.4 20.4V15.1C10.4 14.6219 10.2672 14.1236 10.0964 13.6965C9.92389 13.2653 9.68927 12.8485 9.43565 12.5315C9.42237 12.5149 9.40839 12.4989 9.39374 12.4835L7.58463 10.5791ZM6.5175 9.45584L5.59374 8.48346L5.58032 8.46969C5.40973 8.2991 5.23176 8.03163 5.09688 7.73073C4.95909 7.42336 4.89999 7.15679 4.89999 7.00002V4.70002C4.89999 3.89007 5.48797 3.35002 6.14999 3.35002H10.3278L6.5175 9.45584Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWEmail(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.63534 5.7371C3.95538 6.36848 3.5 7.39295 3.5 9V16C3.5 17.607 3.95538 18.6315 4.63534 19.2629C5.32535 19.9036 6.36497 20.25 7.75 20.25H17.75C19.135 20.25 20.1746 19.9036 20.8647 19.2629C21.5446 18.6315 22 17.607 22 16V9C22 7.39295 21.5446 6.36848 20.8647 5.7371C20.1746 5.09637 19.135 4.75 17.75 4.75H7.75C6.36497 4.75 5.32535 5.09637 4.63534 5.7371ZM3.61466 4.6379C4.67465 3.65363 6.13503 3.25 7.75 3.25H17.75C19.365 3.25 20.8254 3.65363 21.8853 4.6379C22.9554 5.63152 23.5 7.10705 23.5 9V16C23.5 17.893 22.9554 19.3685 21.8853 20.3621C20.8254 21.3464 19.365 21.75 17.75 21.75H7.75C6.13503 21.75 4.67465 21.3464 3.61466 20.3621C2.54462 19.3685 2 17.893 2 16V9C2 7.10705 2.54462 5.63152 3.61466 4.6379ZM18.336 9.03194C18.5945 9.35558 18.5417 9.82751 18.2181 10.086L15.0871 12.5868C13.7837 13.6244 11.7063 13.6244 10.4029 12.5868L10.401 12.5853L7.28102 10.0853C6.95778 9.82627 6.9057 9.35426 7.16471 9.03102C7.42373 8.70778 7.89574 8.6557 8.21898 8.91471L11.3371 11.4132C11.3374 11.4135 11.3377 11.4137 11.3379 11.4139C12.0945 12.0155 13.396 12.0154 14.1524 11.4136C14.1522 11.4137 14.1525 11.4135 14.1524 11.4136L17.2819 8.91398C17.6056 8.65548 18.0775 8.70829 18.336 9.03194Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWEdit(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.7673 1.93726C16.9341 1.78806 18.1145 2.26518 19.3139 3.39373L19.3153 3.39503C20.5187 4.53312 21.0666 5.68762 20.9844 6.8635C20.905 7.99975 20.2463 8.96146 19.4951 9.75501L18.225 11.0994C18.1726 11.1826 18.1045 11.2543 18.0253 11.3108L11.2892 18.4407C11.0579 18.6926 10.7464 18.906 10.4511 19.0639C10.152 19.2238 9.80604 19.3606 9.48125 19.4184L9.47625 19.4193L6.2574 19.969C5.47684 20.1036 4.72834 19.9086 4.19514 19.4029C3.66268 18.898 3.4274 18.1616 3.51456 17.3771L3.51482 17.3749L3.88642 14.1208C3.92958 13.7971 4.04979 13.4468 4.1915 13.143C4.3327 12.8402 4.52535 12.5191 4.75334 12.2764L4.7548 12.2749L11.5909 5.03908L11.5994 5.03008L12.9648 3.58489C13.7163 2.79102 14.6399 2.08143 15.7673 1.93726ZM18.4048 8.72489L17.2916 9.90314C15.1419 9.53548 13.4249 7.91155 12.948 5.78692L14.0546 4.61556C14.7229 3.90968 15.3452 3.50345 15.9576 3.42514C16.1179 3.40465 16.2923 3.40496 16.4823 3.43661C16.9718 3.51816 17.5649 3.80776 18.2855 4.48564C19.2913 5.43718 19.5283 6.18244 19.488 6.7589C19.4542 7.24338 19.2171 7.74497 18.7921 8.28071C18.6768 8.42614 18.5476 8.57409 18.4048 8.72489ZM5.84661 13.3035L11.7621 7.04217C12.5045 9.00381 14.11 10.5197 16.1085 11.1554L10.1947 17.4148L10.1858 17.4246C10.1076 17.5104 9.95144 17.6301 9.74385 17.741C9.5391 17.8505 9.34608 17.9185 9.22081 17.9412L6.0037 18.4907L6.00254 18.4909C5.62311 18.5563 5.37161 18.4513 5.22731 18.3145C5.08239 18.1771 4.96276 17.9287 5.00527 17.5438L5.00539 17.5428L5.37419 14.3133C5.39206 14.1867 5.45168 13.9898 5.55094 13.7769C5.65203 13.5602 5.76464 13.3909 5.84661 13.3035ZM3.25 21.75C2.83579 21.75 2.5 22.0858 2.5 22.5C2.5 22.9142 2.83579 23.25 3.25 23.25H21.25C21.6642 23.25 22 22.9142 22 22.5C22 22.0858 21.6642 21.75 21.25 21.75H3.25Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWSettings(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.59835 9.84836C10.3016 9.1451 11.2554 8.75001 12.25 8.75001C13.2446 8.75001 14.1984 9.1451 14.9017 9.84836C15.6049 10.5516 16 11.5055 16 12.5C16 13.4946 15.6049 14.4484 14.9017 15.1517C14.1984 15.8549 13.2446 16.25 12.25 16.25C11.2554 16.25 10.3016 15.8549 9.59835 15.1517C8.89509 14.4484 8.5 13.4946 8.5 12.5C8.5 11.5055 8.89509 10.5516 9.59835 9.84836ZM12.25 10.25C11.6533 10.25 11.081 10.4871 10.659 10.909C10.2371 11.331 10 11.9033 10 12.5C10 13.0967 10.2371 13.669 10.659 14.091C11.081 14.513 11.6533 14.75 12.25 14.75C12.8467 14.75 13.419 14.513 13.841 14.091C14.2629 13.669 14.5 13.0967 14.5 12.5C14.5 11.9033 14.2629 11.331 13.841 10.909C13.419 10.4871 12.8467 10.25 12.25 10.25Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.85347 4.27018C9.5858 3.82423 9.02209 3.68551 8.60347 3.93457L8.59256 3.94105L6.86251 4.93096C6.31514 5.24375 6.1263 5.95289 6.4394 6.4948L5.79 6.87001L6.43888 6.49391C6.97395 7.41704 7.11779 8.42882 6.63982 9.25823C6.16192 10.0875 5.21479 10.47 4.15 10.47C3.51678 10.47 3 10.9917 3 11.62V13.38C3 14.0084 3.51678 14.53 4.15 14.53C5.21479 14.53 6.16192 14.9125 6.63982 15.7418C7.11747 16.5707 6.97413 17.5816 6.43994 18.5043C6.28923 18.7681 6.2491 19.0808 6.32837 19.3741C6.40766 19.6675 6.59997 19.9175 6.86316 20.0694L6.86424 20.0701L8.60352 21.0654C9.02214 21.3144 9.58578 21.1758 9.85345 20.7299L9.96093 20.5442C10.4958 19.6214 11.302 18.9925 12.2587 18.9925C13.2162 18.9925 14.02 19.6219 14.55 20.5458L14.5507 20.547L14.6565 20.7298C14.9242 21.1758 15.4879 21.3145 15.9065 21.0655L15.9174 21.059L17.6475 20.0691C18.1934 19.7571 18.3851 19.0578 18.0698 18.5038C17.5358 17.5813 17.3926 16.5705 17.8702 15.7418C18.3481 14.9125 19.2952 14.53 20.36 14.53C20.9932 14.53 21.51 14.0084 21.51 13.38V11.62C21.51 10.9868 20.9884 10.47 20.36 10.47C19.2952 10.47 18.3481 10.0875 17.8702 9.25824C17.3923 8.42899 17.536 7.41744 18.0708 6.49445C18.3836 5.95258 18.1951 5.24391 17.6479 4.93119L15.9065 3.93466C15.4879 3.6856 14.9242 3.82423 14.6565 4.27019L14.5491 4.45579C14.0142 5.3786 13.208 6.00751 12.2512 6.00751C11.2939 6.00751 10.4902 5.37825 9.96021 4.45455L9.95933 4.45301L9.85347 4.27018ZM7.84248 2.64193C9.00191 1.95656 10.4726 2.37704 11.1446 3.50654L11.1491 3.51421L11.2591 3.70423L11.2607 3.70701C11.6307 4.35247 12.0166 4.50751 12.2512 4.50751C12.487 4.50751 12.8759 4.35115 13.2509 3.70423L13.3654 3.50651C14.0374 2.377 15.5081 1.95656 16.6675 2.64193L18.3921 3.62883C19.6647 4.35604 20.0963 5.98713 19.3694 7.24522L19.3689 7.24611C18.9939 7.89298 19.0528 8.3062 19.1698 8.50929C19.2869 8.71249 19.6148 8.97001 20.36 8.97001C21.8116 8.97001 23.01 10.1532 23.01 11.62V13.38C23.01 14.8317 21.8268 16.03 20.36 16.03C19.6148 16.03 19.2869 16.2875 19.1698 16.4907C19.0528 16.6938 18.9939 17.107 19.3689 17.7539L19.3712 17.7579C20.0944 19.0235 19.6657 20.6431 18.3925 21.371L16.6674 22.3581C15.508 23.0434 14.0374 22.623 13.3654 21.4935L13.3609 21.4858L13.2509 21.2958L13.2493 21.293C12.8793 20.6476 12.4934 20.4925 12.2587 20.4925C12.023 20.4925 11.6341 20.6489 11.2591 21.2958L11.1446 21.4935C10.4726 22.623 9.00199 23.0434 7.84257 22.3581L6.11749 21.371L6.11576 21.37C5.50771 21.0199 5.06339 20.4428 4.88032 19.7655C4.69726 19.0881 4.7904 18.3658 5.1393 17.7571L5.14111 17.7539C5.51605 17.107 5.45721 16.6938 5.34018 16.4907C5.22308 16.2875 4.89521 16.03 4.15 16.03C2.68322 16.03 1.5 14.8317 1.5 13.38V11.62C1.5 10.1684 2.68322 8.97001 4.15 8.97001C4.89521 8.97001 5.22308 8.71249 5.34018 8.50929C5.45721 8.3062 5.51606 7.89298 5.14112 7.24611L5.1406 7.24522C4.41378 5.98726 4.84518 4.35639 6.11749 3.62906L7.84248 2.64193Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWBook(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 5.16001C2 3.53446 3.34168 2.28621 4.97166 2.42255C7.19026 2.60243 10.4803 3.69902 12.3613 4.87013L12.615 5.02238C12.6176 5.02358 12.6282 5.02843 12.6485 5.0335C12.6757 5.04029 12.7109 5.04501 12.75 5.04501C12.7891 5.04501 12.8243 5.04029 12.8515 5.0335C12.8708 5.0287 12.8813 5.02409 12.8845 5.0226L13.0505 4.91516C14.9318 3.73144 18.2369 2.62296 20.4559 2.43275C20.4773 2.43092 20.4986 2.43001 20.52 2.43001H20.5508C22.1592 2.31327 23.5 3.53821 23.5 5.17001V17.24C23.5 18.5724 22.4441 19.7966 21.103 19.9642L21.1003 19.9646L20.7746 20.004C18.6891 20.2824 15.4256 21.3603 13.5874 22.3739C13.3163 22.5281 13.0087 22.5825 12.7438 22.5825C12.4805 22.5825 12.1801 22.5288 11.9126 22.3849L11.8846 22.3708C11.8764 22.3667 11.8682 22.3625 11.8601 22.358C10.0207 21.3521 6.75894 20.2811 4.68065 20.0034L4.67752 20.003L4.39189 19.9636C3.05319 19.7935 2 18.5707 2 17.24V5.16001ZM4.8472 3.91737C4.09769 3.85439 3.5 4.40593 3.5 5.16001V17.24C3.5 17.8276 4.00414 18.4034 4.58303 18.4758L4.59249 18.477L4.87935 18.5166L4.88096 18.5168C7.13806 18.8188 10.5657 19.9436 12.5675 21.0352L12.5954 21.0492C12.6047 21.0538 12.6139 21.0587 12.6231 21.0637C12.6231 21.0637 12.6327 21.0683 12.6539 21.0731C12.6784 21.0787 12.7096 21.0825 12.7438 21.0825C12.778 21.0825 12.8076 21.0787 12.8293 21.0737C12.8406 21.0711 12.8471 21.0687 12.8497 21.0678L12.8574 21.0633C14.8588 19.9584 18.3082 18.8189 20.5811 18.5166L20.5897 18.5154L20.917 18.4758L20.9181 18.4757C21.4965 18.4027 22 17.8272 22 17.24V5.17001C22 4.41317 21.3995 3.86378 20.6428 3.92737C20.6219 3.92913 20.601 3.93001 20.58 3.93001H20.5528C18.5725 4.10773 15.5241 5.13245 13.8533 6.18233L13.6756 6.29735C13.3839 6.47839 13.0453 6.54501 12.75 6.54501C12.4566 6.54501 12.1205 6.47914 11.8301 6.30073L11.5731 6.1465C9.89349 5.09911 6.82868 4.07778 4.84948 3.91756L4.8472 3.91737Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.75 5.24001C13.1642 5.24001 13.5 5.57579 13.5 5.99001V20.99C13.5 21.4042 13.1642 21.74 12.75 21.74C12.3358 21.74 12 21.4042 12 20.99V5.99001C12 5.57579 12.3358 5.24001 12.75 5.24001Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.5 8.99001C5.5 8.57579 5.83579 8.24001 6.25 8.24001H8.5C8.91421 8.24001 9.25 8.57579 9.25 8.99001C9.25 9.40422 8.91421 9.74001 8.5 9.74001H6.25C5.83579 9.74001 5.5 9.40422 5.5 8.99001Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.5 11.99C5.5 11.5758 5.83579 11.24 6.25 11.24H9.25C9.66421 11.24 10 11.5758 10 11.99C10 12.4042 9.66421 12.74 9.25 12.74H6.25C5.83579 12.74 5.5 12.4042 5.5 11.99Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWDocument(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.5 7.5C4.5 6.11497 4.84637 5.07535 5.4871 4.38534C6.11848 3.70538 7.14295 3.25 8.75 3.25H16.75C18.357 3.25 19.3815 3.70538 20.0129 4.38534C20.6536 5.07535 21 6.11497 21 7.5V17.5C21 18.885 20.6536 19.9246 20.0129 20.6147C19.3815 21.2946 18.357 21.75 16.75 21.75H8.75C7.14295 21.75 6.11848 21.2946 5.4871 20.6147C4.84637 19.9246 4.5 18.885 4.5 17.5V7.5ZM8.75 1.75C6.85705 1.75 5.38152 2.29462 4.3879 3.36466C3.40363 4.42465 3 5.88503 3 7.5V17.5C3 19.115 3.40363 20.5754 4.3879 21.6353C5.38152 22.7054 6.85705 23.25 8.75 23.25H16.75C18.643 23.25 20.1185 22.7054 21.1121 21.6353C22.0964 20.5754 22.5 19.115 22.5 17.5V7.5C22.5 5.88503 22.0964 4.42465 21.1121 3.36466C20.1185 2.29462 18.643 1.75 16.75 1.75H8.75ZM16 5C16 4.58579 15.6642 4.25 15.25 4.25C14.8358 4.25 14.5 4.58579 14.5 5V7C14.5 8.51421 15.7358 9.75 17.25 9.75H19.25C19.6642 9.75 20 9.41421 20 9C20 8.58579 19.6642 8.25 19.25 8.25H17.25C16.5642 8.25 16 7.68579 16 7V5ZM8 13.5C8 13.0858 8.33579 12.75 8.75 12.75H12.75C13.1642 12.75 13.5 13.0858 13.5 13.5C13.5 13.9142 13.1642 14.25 12.75 14.25H8.75C8.33579 14.25 8 13.9142 8 13.5ZM8.75 16.75C8.33579 16.75 8 17.0858 8 17.5C8 17.9142 8.33579 18.25 8.75 18.25H16.75C17.1642 18.25 17.5 17.9142 17.5 17.5C17.5 17.0858 17.1642 16.75 16.75 16.75H8.75Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWCircleQuestion(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.5 10.5001C9.5 8.97746 10.7273 7.75 12.25 7.75C13.7727 7.75 15.0001 8.97746 15.0001 10.5001C15.0001 11.6883 14.2237 12.3177 13.6868 12.6846C13.217 13.0092 13 13.2469 13 13.6689V13.9218C13 14.3361 12.6642 14.6718 12.25 14.6718C11.8358 14.6718 11.5 14.3361 11.5 13.9218V13.6689C11.5 12.4527 12.2947 11.8229 12.836 11.4492L12.8392 11.447C13.2901 11.1391 13.5001 10.9011 13.5001 10.5001C13.5001 9.80581 12.9442 9.25 12.25 9.25C11.5558 9.25 11 9.80581 11 10.5001C11 10.9143 10.6642 11.2501 10.25 11.2501C9.83579 11.2501 9.5 10.9143 9.5 10.5001Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.2446 16.8016C11.2446 16.2493 11.6923 15.8016 12.2446 15.8016H12.2554C12.8077 15.8016 13.2554 16.2493 13.2554 16.8016C13.2554 17.3539 12.8077 17.8016 12.2554 17.8016H12.2446C11.6923 17.8016 11.2446 17.3539 11.2446 16.8016Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.5 12.5C1.5 6.58579 6.33579 1.75 12.25 1.75C18.1642 1.75 23 6.58579 23 12.5C23 18.4142 18.1642 23.25 12.25 23.25C6.33579 23.25 1.5 18.4142 1.5 12.5ZM12.25 3.25C7.16421 3.25 3 7.41421 3 12.5C3 17.5858 7.16421 21.75 12.25 21.75C17.3358 21.75 21.5 17.5858 21.5 12.5C21.5 7.41421 17.3358 3.25 12.25 3.25Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWDice(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0137 1.50019C14.4421 1.49488 13.8596 1.60184 13.3001 1.83342L3.96608 5.70053C1.72803 6.62775 0.656451 9.21231 1.58397 11.4515L5.44927 20.7825C6.37679 23.0217 8.96187 24.0933 11.1999 23.1663L20.5339 19.2992C22.772 18.372 23.8436 15.7874 22.9161 13.5483L19.0508 4.21727C18.3551 2.53783 16.7281 1.5152 15.0137 1.50019ZM15.0102 3.25325C16.0399 3.2559 17.0007 3.86667 17.425 4.89113L21.2886 14.2221C21.8546 15.588 21.2258 17.106 19.8605 17.6714L10.5265 21.5385C9.16108 22.1042 7.64109 21.4745 7.07509 20.1086L3.21153 10.7776C2.64583 9.41173 3.27458 7.89378 4.63995 7.32838L13.974 3.46105C14.3154 3.31992 14.6669 3.25236 15.0102 3.25325ZM14.0099 6.78003C13.6598 6.78003 13.324 6.9191 13.0765 7.16659C12.829 7.41408 12.6899 7.74968 12.6899 8.09999C12.6899 8.45002 12.829 8.7856 13.0765 9.0334C13.324 9.28088 13.6598 9.41996 14.0099 9.41996C14.3599 9.41996 14.6958 9.28088 14.9433 9.0334C15.1908 8.7856 15.3298 8.45002 15.3298 8.09999C15.3298 7.74968 15.1908 7.41408 14.9433 7.16659C14.6958 6.9191 14.3599 6.78003 14.0099 6.78003ZM7.84995 9.41996C7.49992 9.41996 7.16434 9.55903 6.91655 9.80652C6.66906 10.054 6.52999 10.3896 6.52999 10.7399C6.52999 11.0899 6.66906 11.4255 6.91655 11.6733C7.16434 11.9208 7.49992 12.0599 7.84995 12.0599C8.20027 12.0599 8.53586 11.9208 8.78335 11.6733C9.03084 11.4255 9.16991 11.0899 9.16991 10.7399C9.16991 10.3896 9.03084 10.054 8.78335 9.80652C8.53586 9.55903 8.20027 9.41996 7.84995 9.41996ZM16.6499 12.9397C16.2999 12.9397 15.964 13.0787 15.7165 13.3262C15.4691 13.574 15.33 13.9096 15.33 14.2596C15.33 14.6099 15.4691 14.9455 15.7165 15.193C15.964 15.4405 16.2999 15.5796 16.6499 15.5796C17 15.5796 17.3359 15.4405 17.5833 15.193C17.8308 14.9455 17.9699 14.6099 17.9699 14.2596C17.9699 13.9096 17.8308 13.574 17.5833 13.3262C17.3359 13.0787 17 12.9397 16.6499 12.9397ZM10.4899 15.5796C10.1398 15.5796 9.80426 15.7186 9.55647 15.9661C9.30898 16.2139 9.16991 16.5495 9.16991 16.8995C9.16991 17.2499 9.30898 17.5854 9.55647 17.8329C9.80426 18.0804 10.1398 18.2195 10.4899 18.2195C10.8402 18.2195 11.1758 18.0804 11.4233 17.8329C11.6708 17.5854 11.8098 17.2499 11.8098 16.8995C11.8098 16.5495 11.6708 16.2139 11.4233 15.9661C11.1758 15.7186 10.8402 15.5796 10.4899 15.5796Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWColour(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.91 8.43L12.25 2.77L6.59 8.43C3.47 11.55 3.47 16.62 6.59 19.74C8.15 21.3 10.2 22.08 12.25 22.08C14.3 22.08 16.35 21.3 17.91 19.74C21.03 16.62 21.03 11.55 17.91 8.43ZM12.25 20.09C10.65 20.09 9.14 19.47 8.01 18.33C6.87 17.19 6.25 15.69 6.25 14.09C6.25 12.49 6.87 10.98 8.01 9.85L12.25 5.6V20.09Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWMore(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.5 12.5C2.5 10.9858 3.73579 9.75 5.25 9.75C6.76421 9.75 8 10.9858 8 12.5C8 14.0142 6.76421 15.25 5.25 15.25C3.73579 15.25 2.5 14.0142 2.5 12.5ZM5.25 11.25C4.56421 11.25 4 11.8142 4 12.5C4 13.1858 4.56421 13.75 5.25 13.75C5.93579 13.75 6.5 13.1858 6.5 12.5C6.5 11.8142 5.93579 11.25 5.25 11.25ZM9.5 12.5C9.5 10.9858 10.7358 9.75 12.25 9.75C13.7642 9.75 15 10.9858 15 12.5C15 14.0142 13.7642 15.25 12.25 15.25C10.7358 15.25 9.5 14.0142 9.5 12.5ZM12.25 11.25C11.5642 11.25 11 11.8142 11 12.5C11 13.1858 11.5642 13.75 12.25 13.75C12.9358 13.75 13.5 13.1858 13.5 12.5C13.5 11.8142 12.9358 11.25 12.25 11.25ZM16.5 12.5C16.5 10.9858 17.7358 9.75 19.25 9.75C20.7642 9.75 22 10.9858 22 12.5C22 14.0142 20.7642 15.25 19.25 15.25C17.7358 15.25 16.5 14.0142 16.5 12.5ZM19.25 11.25C18.5642 11.25 18 11.8142 18 12.5C18 13.1858 18.5642 13.75 19.25 13.75C19.9358 13.75 20.5 13.1858 20.5 12.5C20.5 11.8142 19.9358 11.25 19.25 11.25Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWAccount(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.25 3.25C7.14137 3.25 3 7.39137 3 12.5C3 14.7736 3.82027 16.8556 5.18102 18.4662C5.54334 17.7869 6.11897 17.1773 6.86129 16.6778L6.86502 16.6753L6.86503 16.6753C8.38359 15.6666 10.3414 15.185 12.2575 15.185C14.1734 15.185 16.1274 15.6665 17.6371 16.6767L17.6387 16.6778C18.381 17.1773 18.9567 17.7869 19.319 18.4662C20.6797 16.8556 21.5 14.7736 21.5 12.5C21.5 7.39137 17.3586 3.25 12.25 3.25ZM13.8871 23.1261C19.0472 22.3377 23 17.8805 23 12.5C23 6.56294 18.1871 1.75 12.25 1.75C6.31294 1.75 1.5 6.56294 1.5 12.5C1.5 18.4371 6.31294 23.25 12.25 23.25C12.4355 23.25 12.62 23.2453 12.8032 23.236C13.0768 23.2221 13.3477 23.198 13.6155 23.1641C13.7064 23.1526 13.7969 23.1399 13.8871 23.1261ZM18.1716 19.6C18.0038 19.0356 17.573 18.4417 16.8021 17.9228C15.5919 17.1133 13.9463 16.685 12.2575 16.685C10.5695 16.685 8.91811 17.113 7.69686 17.9235C6.92666 18.4422 6.49614 19.0359 6.32838 19.6C7.31079 20.4227 8.46266 21.0433 9.72543 21.4013C10.5279 21.6284 11.3748 21.75 12.25 21.75C13.1252 21.75 13.9721 21.6284 14.7746 21.4013C16.0373 21.0433 17.1892 20.4227 18.1716 19.6ZM12.25 7.48C10.8457 7.48 9.72 8.61272 9.72 10.01C9.72 11.3588 10.7736 12.4585 12.1087 12.5284C12.2006 12.5209 12.2987 12.5202 12.3939 12.5283C13.7232 12.4572 14.7712 11.3618 14.78 10.0079C14.7789 8.6131 13.6451 7.48 12.25 7.48ZM8.22 10.01C8.22 7.78728 10.0143 5.98 12.25 5.98C14.4742 5.98 16.28 7.78579 16.28 10.01V10.0142H16.28C16.2677 12.1826 14.5622 13.9557 12.3956 14.0296C12.3516 14.0311 12.3075 14.0287 12.2639 14.0225C12.2682 14.0231 12.2691 14.023 12.2663 14.0228C12.2637 14.0227 12.2594 14.0225 12.2537 14.0225C12.2415 14.0225 12.2301 14.0233 12.223 14.0242C12.1837 14.0291 12.1441 14.0309 12.1044 14.0296C9.94161 13.9558 8.22 12.1855 8.22 10.01Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWShare(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_414_13909)">
          <path
            d="M19.4259 24.4C18.3299 24.4 17.2944 23.9815 16.5178 23.2127C15.7412 22.444 15.3097 21.4276 15.3097 20.3428C15.3097 19.873 15.396 19.4032 15.5514 18.9676L9.11399 15.2606C8.81197 15.6023 8.45817 15.9013 8.0526 16.1319C6.48209 17.0287 4.3852 16.7469 3.09946 15.4827C2.34009 14.7311 1.9 13.6805 1.9 12.6043C1.9 11.5195 2.33146 10.4945 3.10809 9.72579C3.88471 8.95706 4.92021 8.53853 6.01612 8.53853H6.02475C6.74097 8.53853 7.43993 8.72644 8.06123 9.07664C8.45817 9.30726 8.8206 9.59767 9.12262 9.93933L15.56 6.2238C15.4047 5.78819 15.3184 5.31841 15.3184 4.85717C15.3184 4.31906 15.4219 3.79803 15.629 3.30263C15.8361 2.80723 16.1381 2.36307 16.5178 1.98725C16.8975 1.61142 17.3548 1.31247 17.8553 1.10748C18.8563 0.697491 19.9954 0.697491 20.9964 1.10748C21.4969 1.31247 21.9456 1.61142 22.3339 1.98725C22.7136 2.36307 23.0156 2.80723 23.2227 3.30263C23.4298 3.79803 23.5333 4.31906 23.5333 4.85717C23.5333 5.39528 23.4298 5.91631 23.2227 6.41171C23.0156 6.90712 22.7136 7.35127 22.3339 7.7271C21.9542 8.10292 21.5055 8.40187 21.005 8.60686C19.8401 9.08519 18.4766 8.99123 17.3894 8.37625C16.9838 8.14563 16.63 7.85522 16.328 7.50502L9.88199 11.2205C10.0373 11.6562 10.1236 12.1259 10.1236 12.5872C10.1236 13.057 10.0459 13.5182 9.88199 13.9538L16.3194 17.6693C16.6214 17.3277 16.9838 17.0287 17.3807 16.8066C18.002 16.4564 18.701 16.2685 19.4172 16.2685H19.4259C19.9695 16.2685 20.4959 16.371 20.9964 16.576C21.4969 16.781 21.9456 17.08 22.3339 17.4558C22.7136 17.8316 23.0156 18.2843 23.2227 18.7797C23.4298 19.2751 23.5333 19.7962 23.5333 20.3343C23.5333 21.419 23.1019 22.444 22.3339 23.2127C21.5659 23.9644 20.5131 24.4 19.4259 24.4ZM17.2168 18.9762L17.1823 19.036C16.9493 19.4289 16.8285 19.8816 16.8285 20.3343C16.8285 21.0176 17.1046 21.6667 17.5878 22.1536C18.5629 23.1188 20.2888 23.1188 21.2639 22.1536C21.7557 21.6667 22.0232 21.0261 22.0232 20.3343C22.0232 19.9926 21.9542 19.6595 21.8248 19.352C21.6953 19.0445 21.5055 18.7541 21.2639 18.5149C21.0222 18.2758 20.7375 18.0879 20.4182 17.9597C20.0989 17.8316 19.7883 17.7804 19.4172 17.7633C18.9685 17.7633 18.5198 17.8829 18.1315 18.1049C17.7604 18.3099 17.4411 18.6174 17.2168 18.9762ZM6.01612 10.0162C5.31715 10.0162 4.66134 10.281 4.16947 10.7678C3.67761 11.2547 3.41011 11.9039 3.41011 12.5872C3.41011 13.262 3.68624 13.9282 4.16947 14.4065C4.98062 15.2094 6.30951 15.3888 7.30186 14.8165C7.68155 14.603 7.9922 14.2955 8.22519 13.9282L8.25107 13.8769C8.48406 13.484 8.60487 13.0399 8.60487 12.5872C8.60487 12.1345 8.48406 11.6818 8.25107 11.2889C8.01808 10.896 7.69018 10.5799 7.30186 10.3579C6.91355 10.1358 6.47346 10.0162 6.01612 10.0162ZM17.1823 6.13839C17.4066 6.52275 17.7432 6.84733 18.1315 7.06941C18.8218 7.46231 19.6847 7.51356 20.4182 7.21461C20.7375 7.08649 21.0222 6.89858 21.2639 6.65942C21.5055 6.42026 21.6953 6.13839 21.8248 5.82236C21.9542 5.50632 22.0232 5.17321 22.0232 4.84009C22.0232 4.50697 21.9542 4.16532 21.8248 3.85782C21.6953 3.54179 21.5055 3.25992 21.2639 3.02076C21.0222 2.7816 20.7375 2.59369 20.4182 2.46557C19.7883 2.20933 19.0634 2.20933 18.4249 2.46557C18.1056 2.59369 17.8208 2.7816 17.5792 3.02076C17.3376 3.25992 17.1478 3.54179 17.0183 3.85782C16.8889 4.17386 16.8198 4.49843 16.8198 4.84009C16.8285 5.29279 16.9493 5.74548 17.1823 6.13839Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_414_13909">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.75 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function GWGift(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.96997 10.5C3.96997 10.0858 4.30576 9.75 4.71997 9.75H20.72C21.1342 9.75 21.47 10.0858 21.47 10.5V18.5C21.47 20.0415 21.2227 21.3079 20.3753 22.1553C19.5279 23.0028 18.2615 23.25 16.72 23.25H8.71997C7.17842 23.25 5.91206 23.0028 5.06464 22.1553C4.21722 21.3079 3.96997 20.0415 3.96997 18.5V10.5ZM5.46997 11.25V18.5C5.46997 19.9585 5.72272 20.6921 6.1253 21.0947C6.52788 21.4972 7.26152 21.75 8.71997 21.75H16.72C18.1784 21.75 18.9121 21.4972 19.3146 21.0947C19.7172 20.6921 19.97 19.9585 19.97 18.5V11.25H5.46997Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.24722 6.57381C4.10094 6.74556 4 7.03929 4 7.5V8.5C4 8.96071 4.10094 9.25444 4.24722 9.42619C4.3739 9.57493 4.63538 9.75 5.25 9.75H20.25C20.8258 9.75 21.0961 9.57991 21.2361 9.41945C21.3923 9.24039 21.5 8.94239 21.5 8.5V7.5C21.5 7.05761 21.3923 6.75961 21.2361 6.58055C21.0961 6.42009 20.8258 6.25 20.25 6.25H5.25C4.63538 6.25 4.3739 6.42507 4.24722 6.57381ZM3.10528 5.60119C3.5961 5.02493 4.33462 4.75 5.25 4.75H20.25C21.1442 4.75 21.8739 5.02991 22.3664 5.59445C22.8427 6.14039 23 6.84239 23 7.5V8.5C23 9.15761 22.8427 9.85961 22.3664 10.4056C21.8739 10.9701 21.1442 11.25 20.25 11.25H5.25C4.33462 11.25 3.5961 10.9751 3.10528 10.3988C2.63406 9.84556 2.5 9.13929 2.5 8.5V7.5C2.5 6.86071 2.63406 6.15444 3.10528 5.60119Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.1397 3.31027C9.06259 3.23316 8.92747 3.23316 8.85036 3.31027L7.43036 4.73027C7.42404 4.73659 7.41825 4.74316 7.41297 4.74994H10.5794L9.1397 3.31027ZM7.7897 2.24961C8.45259 1.58672 9.53747 1.58672 10.2004 2.24961L12.9204 4.96961C13.1349 5.18411 13.199 5.5067 13.0829 5.78695C12.9669 6.06721 12.6934 6.24994 12.39 6.24994H6.87003C6.66012 6.24994 6.45982 6.16197 6.31779 6.00741C5.70559 5.3412 5.72578 4.31353 6.3697 3.66961L7.7897 2.24961Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.6398 3.31027C16.5627 3.23316 16.4276 3.23316 16.3504 3.31027L14.9108 4.74994H18.0772C18.0719 4.74316 18.0661 4.73659 18.0598 4.73027L16.6398 3.31027ZM15.2898 2.24961C15.9527 1.58672 17.0376 1.58672 17.7004 2.24961L19.1204 3.66961C19.7644 4.31353 19.7846 5.3412 19.1724 6.00741C19.0303 6.16197 18.83 6.24994 18.6201 6.24994H13.1001C12.7968 6.24994 12.5233 6.06721 12.4072 5.78695C12.2911 5.5067 12.3553 5.18411 12.5698 4.96961L15.2898 2.24961Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.93994 10.5C8.93994 10.0858 9.27573 9.75 9.68994 9.75H15.7199C16.1342 9.75 16.4699 10.0858 16.4699 10.5V15.63C16.4699 17.033 14.909 17.8541 13.7539 17.084L13.7507 17.0819L12.8629 16.4833C12.789 16.4347 12.6842 16.428 12.5893 16.4884L11.6451 17.1112C10.4859 17.8552 8.93994 17.0449 8.93994 15.64V10.5ZM10.4399 11.25V15.64C10.4399 15.8341 10.6519 15.9635 10.8321 15.8506L11.7725 15.2303C12.3566 14.8523 13.1104 14.8456 13.696 15.236L13.6992 15.2381L14.5871 15.8367C14.7518 15.9453 14.9699 15.8266 14.9699 15.63V11.25H10.4399Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWBasket(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0896 1.96894C10.3829 2.26143 10.3836 2.7363 10.0911 3.0296L7.52774 5.6H17.9723L15.4089 3.0296C15.1165 2.7363 15.1171 2.26143 15.4104 1.96894C15.7037 1.67645 16.1786 1.6771 16.4711 1.9704L20.0907 5.6H20.53C21.122 5.6 21.9031 5.62085 22.5186 6.03311C23.2148 6.49942 23.5 7.30189 23.5 8.35C23.5 9.49331 23.2418 10.3645 22.4757 10.8061C22.2918 10.9121 22.1001 10.9788 21.9137 11.0215L20.3066 19.4011C20.1297 20.3247 19.8987 21.3485 19.1788 22.1028C18.4269 22.8907 17.289 23.25 15.64 23.25H9.61C8.05817 23.25 6.92682 22.8623 6.14883 22.0745C5.39199 21.308 5.08732 20.2765 4.92 19.2621L3.57475 11.0188C3.39197 10.9761 3.20441 10.9099 3.02425 10.8061C2.25815 10.3645 2 9.49331 2 8.35C2 7.30189 2.28518 6.49942 2.98138 6.03311C3.5969 5.62085 4.37803 5.6 4.97 5.6H5.40934L9.02894 1.9704C9.32143 1.6771 9.7963 1.67645 10.0896 1.96894ZM5.10784 11.1L6.4 19.0179C6.39997 19.0177 6.40003 19.0181 6.4 19.0179C6.55268 19.9432 6.7931 20.5921 7.21617 21.0205C7.61818 21.4277 8.30183 21.75 9.61 21.75H15.64C17.101 21.75 17.7481 21.4293 18.0937 21.0672C18.4713 20.6715 18.6503 20.0753 18.8334 19.1189L20.3713 11.1H5.10784ZM3.81612 7.27939C3.70982 7.35058 3.5 7.54811 3.5 8.35C3.5 9.34937 3.73342 9.48354 3.77242 9.50597C3.83083 9.53963 3.94013 9.57576 4.15918 9.59186C4.3262 9.60413 4.4983 9.60284 4.71205 9.60124C4.79163 9.60064 4.87698 9.6 4.97 9.6H20.53C20.623 9.6 20.7084 9.60064 20.788 9.60124C21.0017 9.60284 21.1738 9.60413 21.3408 9.59186C21.5599 9.57576 21.6683 9.5401 21.7267 9.50644C21.7658 9.48402 22 9.34937 22 8.35C22 7.5481 21.7902 7.35058 21.6839 7.27939C21.4969 7.15415 21.168 7.1 20.53 7.1H4.97C4.33197 7.1 4.0031 7.15415 3.81612 7.27939ZM10.51 13.75C10.9242 13.75 11.26 14.0858 11.26 14.5V18.05C11.26 18.4642 10.9242 18.8 10.51 18.8C10.0958 18.8 9.76 18.4642 9.76 18.05V14.5C9.76 14.0858 10.0958 13.75 10.51 13.75ZM15.11 13.75C15.5242 13.75 15.86 14.0858 15.86 14.5V18.05C15.86 18.4642 15.5242 18.8 15.11 18.8C14.6958 18.8 14.36 18.4642 14.36 18.05V14.5C14.36 14.0858 14.6958 13.75 15.11 13.75Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWImportant(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.25 7.5C12.6642 7.5 13 7.83579 13 8.25V13.5C13 13.9142 12.6642 14.25 12.25 14.25C11.8358 14.25 11.5 13.9142 11.5 13.5V8.25C11.5 7.83579 11.8358 7.5 12.25 7.5Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4465 3.57041C12.6962 3.14226 11.7813 3.14443 11.045 3.56953L5.1077 6.99794C4.36577 7.43498 3.90997 8.22968 3.90997 9.08003V15.92C3.90997 16.7836 4.36836 17.5753 5.10497 18.0005L11.0421 21.4289L11.0435 21.4297C11.7938 21.8578 12.7087 21.8556 13.445 21.4305L19.38 18.0034L19.3824 18.0021C20.1242 17.565 20.58 16.7703 20.58 15.92V9.08003C20.58 8.221 20.1254 7.43563 19.3823 6.99794L19.38 6.99661L13.4479 3.57118L13.4465 3.57041ZM10.295 2.27047C11.4982 1.57583 12.9827 1.57774 14.1921 2.26882L14.1951 2.2705L20.14 5.70335C21.3356 6.40592 22.08 7.67993 22.08 9.08003V15.92C22.08 17.3088 21.3367 18.5934 20.14 19.2967L20.1351 19.2996L14.1951 22.7295C12.9918 23.4242 11.5073 23.4223 10.2979 22.7312L10.2949 22.7295L4.355 19.2996C3.1516 18.6048 2.40997 17.3164 2.40997 15.92V9.08003C2.40997 7.69125 3.15327 6.40661 4.35001 5.70337L4.35493 5.70048L10.295 2.27047Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.25 15.7C12.8023 15.7 13.25 16.1477 13.25 16.7V16.8C13.25 17.3523 12.8023 17.8 12.25 17.8C11.6977 17.8 11.25 17.3523 11.25 16.8V16.7C11.25 16.1477 11.6977 15.7 12.25 15.7Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWVisible(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.2498 3.47021C8.40186 3.47021 4.89826 5.73882 2.50734 9.49718C1.96214 10.3516 1.71484 11.4462 1.71484 12.4952C1.71484 13.5441 1.96205 14.6384 2.50703 15.4928C4.89795 19.2514 8.4017 21.5202 12.2498 21.5202C16.098 21.5202 19.6017 19.2514 21.9927 15.4928C22.5376 14.6384 22.7848 13.5441 22.7848 12.4952C22.7848 11.4464 22.5376 10.352 21.9927 9.49767C19.6017 5.73901 16.098 3.47021 12.2498 3.47021ZM3.77266 10.3028C5.96174 6.86142 9.03799 4.97021 12.2498 4.97021C15.4617 4.97021 18.538 6.86142 20.727 10.3028L20.7277 10.3037C21.0822 10.8593 21.2848 11.6545 21.2848 12.4952C21.2848 13.336 21.0822 14.1312 20.7277 14.6867L20.727 14.6877C18.538 18.129 15.4617 20.0202 12.2498 20.0202C9.03799 20.0202 5.96174 18.129 3.77266 14.6877L3.77204 14.6867C3.41745 14.1312 3.21484 13.336 3.21484 12.4952C3.21484 11.6545 3.41745 10.8593 3.77204 10.3037L3.77266 10.3028ZM9.41992 12.4999C9.41992 10.9341 10.6841 9.66992 12.2499 9.66992C13.8157 9.66992 15.0799 10.9341 15.0799 12.4999C15.0799 14.0657 13.8157 15.3299 12.2499 15.3299C10.6841 15.3299 9.41992 14.0657 9.41992 12.4999ZM12.2499 8.16992C9.85571 8.16992 7.91992 10.1057 7.91992 12.4999C7.91992 14.8941 9.85571 16.8299 12.2499 16.8299C14.6441 16.8299 16.5799 14.8941 16.5799 12.4999C16.5799 10.1057 14.6441 8.16992 12.2499 8.16992Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWGlobal(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.75 2.17442C7.04734 2.17442 2.42442 6.79734 2.42442 12.5C2.42442 18.2027 7.04734 22.8256 12.75 22.8256C18.4527 22.8256 23.0756 18.2027 23.0756 12.5C23.0756 6.79734 18.4527 2.17442 12.75 2.17442ZM0.75 12.5C0.75 5.87258 6.12258 0.5 12.75 0.5C19.3774 0.5 24.75 5.87258 24.75 12.5C24.75 19.1274 19.3774 24.5 12.75 24.5C6.12258 24.5 0.75 19.1274 0.75 12.5Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.44767 2.45349C7.44767 1.99111 7.82251 1.61628 8.28488 1.61628H9.40116C9.67035 1.61628 9.92313 1.74572 10.0805 1.96414C10.2378 2.18256 10.2805 2.46331 10.1953 2.71865C8.07599 9.06561 8.07599 15.9344 10.1953 22.2814C10.2805 22.5367 10.2378 22.8174 10.0805 23.0359C9.92313 23.2543 9.67035 23.3837 9.40116 23.3837H8.28488C7.82251 23.3837 7.44767 23.0089 7.44767 22.5465C7.44767 22.0922 7.80951 21.7225 8.2607 21.7097C6.4883 15.6994 6.4883 9.30062 8.2607 3.29035C7.8095 3.27755 7.44767 2.90778 7.44767 2.45349Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.8337 1.65938C16.2723 1.51294 16.7465 1.74976 16.893 2.18833C19.1272 8.8795 19.1272 16.1205 16.893 22.8117C16.7465 23.2502 16.2723 23.4871 15.8337 23.3406C15.3951 23.1942 15.1583 22.7199 15.3047 22.2814C17.424 15.9344 17.424 9.06561 15.3047 2.71865C15.1583 2.28007 15.3951 1.80582 15.8337 1.65938Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.21414 15.1695C2.43256 15.0122 2.71331 14.9695 2.96865 15.0547C9.31561 17.174 16.1844 17.174 22.5314 15.0547C22.7867 14.9695 23.0674 15.0122 23.2859 15.1695C23.5043 15.3269 23.6337 15.5796 23.6337 15.8488V16.9651C23.6337 17.4275 23.2589 17.8023 22.7965 17.8023C22.3422 17.8023 21.9725 17.4405 21.9597 16.9893C15.9494 18.7617 9.55062 18.7617 3.54035 16.9893C3.52755 17.4405 3.15778 17.8023 2.70349 17.8023C2.24111 17.8023 1.86628 17.4275 1.86628 16.9651V15.8488C1.86628 15.5796 1.99572 15.3269 2.21414 15.1695Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.5314 9.94527C16.1844 7.82599 9.31561 7.82599 2.96865 9.94527C2.53007 10.0917 2.05582 9.8549 1.90938 9.41632C1.76294 8.97775 1.99976 8.5035 2.43833 8.35705C9.1295 6.12284 16.3705 6.12284 23.0617 8.35705C23.5002 8.5035 23.7371 8.97775 23.5906 9.41632C23.4442 9.8549 22.9699 10.0917 22.5314 9.94527Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}

export function GWCalendarDays(props) {
  const { style, ...rest } = props;
  const width = props.width || 24;

  return (
    <SvgIcon style={style} {...rest}>
      <svg
        width={width}
        height={width}
        viewBox={`0 0 ${width} ${width}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9 2.5C9 2.08579 8.66421 1.75 8.25 1.75C7.83579 1.75 7.5 2.08579 7.5 2.5V3.28025C5.96409 3.40808 4.7462 3.94034 3.8879 4.86466C2.90363 5.92465 2.5 7.38503 2.5 9V17.5C2.5 19.115 2.90363 20.5754 3.8879 21.6353C4.88152 22.7054 6.35705 23.25 8.25 23.25H16.25C18.143 23.25 19.6185 22.7054 20.6121 21.6353C21.5964 20.5754 22 19.115 22 17.5V9C22 7.38503 21.5964 5.92465 20.6121 4.86466C19.7538 3.94034 18.5359 3.40808 17 3.28025V2.5C17 2.08579 16.6642 1.75 16.25 1.75C15.8358 1.75 15.5 2.08579 15.5 2.5V3.25H9V2.5ZM7.5 4.78628V5.5C7.5 5.91421 7.83579 6.25 8.25 6.25C8.66421 6.25 9 5.91421 9 5.5V4.75H15.5V5.5C15.5 5.91421 15.8358 6.25 16.25 6.25C16.6642 6.25 17 5.91421 17 5.5V4.78628C18.185 4.90668 18.9859 5.31778 19.5129 5.88534C20.1287 6.54852 20.4726 7.53463 20.4984 8.83997H4.00157C4.02739 7.53463 4.37129 6.54852 4.9871 5.88534C5.51412 5.31778 6.31502 4.90668 7.5 4.78628ZM4 10.34V17.5C4 18.885 4.34637 19.9246 4.9871 20.6147C5.61848 21.2946 6.64295 21.75 8.25 21.75H16.25C17.857 21.75 18.8815 21.2946 19.5129 20.6147C20.1536 19.9246 20.5 18.885 20.5 17.5V10.34H4ZM14.9448 14.2C14.9448 13.6477 15.3925 13.2 15.9448 13.2H15.9538C16.5061 13.2 16.9538 13.6477 16.9538 14.2C16.9538 14.7522 16.5061 15.2 15.9538 15.2H15.9448C15.3925 15.2 14.9448 14.7522 14.9448 14.2ZM15.9448 16.2C15.3925 16.2 14.9448 16.6477 14.9448 17.2C14.9448 17.7522 15.3925 18.2 15.9448 18.2H15.9538C16.5061 18.2 16.9538 17.7522 16.9538 17.2C16.9538 16.6477 16.5061 16.2 15.9538 16.2H15.9448ZM11.2456 14.2C11.2456 13.6477 11.6933 13.2 12.2456 13.2H12.2546C12.8069 13.2 13.2546 13.6477 13.2546 14.2C13.2546 14.7522 12.8069 15.2 12.2546 15.2H12.2456C11.6933 15.2 11.2456 14.7522 11.2456 14.2ZM12.2456 16.2C11.6933 16.2 11.2456 16.6477 11.2456 17.2C11.2456 17.7522 11.6933 18.2 12.2456 18.2H12.2546C12.8069 18.2 13.2546 17.7522 13.2546 17.2C13.2546 16.6477 12.8069 16.2 12.2546 16.2H12.2456ZM7.54443 14.2C7.54443 13.6477 7.99215 13.2 8.54443 13.2H8.55342C9.1057 13.2 9.55342 13.6477 9.55342 14.2C9.55342 14.7522 9.1057 15.2 8.55342 15.2H8.54443C7.99215 15.2 7.54443 14.7522 7.54443 14.2ZM8.54443 16.2C7.99215 16.2 7.54443 16.6477 7.54443 17.2C7.54443 17.7522 7.99215 18.2 8.54443 18.2H8.55342C9.1057 18.2 9.55342 17.7522 9.55342 17.2C9.55342 16.6477 9.1057 16.2 8.55342 16.2H8.54443Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
